// Routes used in the definition of the Wallet routing system
export enum RawRecognitionRoutes {
  RECOGNITION = "/polls/:type(poll|recognition|group-celebration)?/:uuid?/:view(reward)?",
  ACCOUNT = "/:recognitionType",
  ACCOUNT_RECOGNITIONS = "/:type(recognition|group-celebration)?/:uuid?/:view(reward)?"
}
// Routes used for navigation purposes (excluding parameters)
export enum RecognitionRoutes {
  POLLS = "/polls",
  ACCOUNT = "/account",
  OLD_REWARD = "/reward",
  CREATE_RECOGNITION = "/polls/create",
  CREATE_GROUP_CELEBRATION = "/polls/create-group",
  CREATE_POLL = "polls/addPoll",
  MY_ACCOUNT_RECOGNITIONS = "/account/my-recognition",
  MY_ACCOUNT_VOTES = "/account/my-votes",
  MY_ACCOUNT_GROUP_CELEBRATIONS = "/account/my-group-celebrations",
  MY_ACCOUNT_CLOSED_POLLS = "/account/my-closed-polls"
}
